export default "__VITE_ASSET__DadPjvhW__"